import { IAppointmentScheduleResponse, IPrescription } from "@curefit/care-common";
import { ApiManager } from "../api/ApiManager"
import {
    UPDATE_EDIT_CONSULTATION_DETAILS,
    SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE,
    CLEAR_EDIT_PRESCRIPTION_DETAILS,
    FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS,
    SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS,
    UPDATE_EDIT_CURRENT_CONSULTATION_DATA,
    UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA
} from "./ActionTypes"
import { IEHRSavePatientMedicalProfile, INewConfigData } from "../models/patients/IEHRSavePatientMedicalProfile";
import AppUtils from "../utils/AppUtils";
import { IConstituentTemplate } from "../models/PdfTemplatesModels";
import IPatientLifestylePlanWrapper from "../models/patients/IPatientLifestylePlanWrapper";
import { EHRRequestMapper } from "../api/EHRRequestMapper";
import { IOngoingConsultation } from "../models/IOngoingConsultation";
import IDoctorProfile from "../models/IDoctorProfile";
import { IEditConsultationResponse } from "../models/IEditConsultationResponse";
import { RECOMMENDATIONS_SECTIONS, ConsultationStatusConstant, SEQUENTIAL_RECOMMENDATIONS_SECTIONS } from "../utils/AppConstants";
import ITreatmentPlanTemplateResponseObj from "../models/ITreatmentPlanTemplateResponse";


export class EditPrescriptionActions {

    static fetchEditPrescriptionDetailsSuccess = (consultationData: IOngoingConsultation) => {
        return { type: FETCH_EDIT_PRESCRIPTION_DETAILS_SUCCESS, consultationData: consultationData };
    }

    static updateCurrentConsultationData = (medicalProfile: IEHRSavePatientMedicalProfile) => {
        return { type: UPDATE_EDIT_CURRENT_CONSULTATION_DATA, medicalProfile }
    }

    static fetchConsultationPdfTemplates = (dispatch: any, appointmentSchedule: IAppointmentScheduleResponse) => {
        return ApiManager.getOllivanderServiceApis().fetchTemplates(
            appointmentSchedule.doctor.id,
            appointmentSchedule.center.id,
            appointmentSchedule.consultationProduct.subServiceType
        ).then((response: IConstituentTemplate) => {
            const templateIdToNameMap = AppUtils.setPdfTemplatesIdToNameMap(response.constituentTemplates || []);
            const templateNameToDataMap = AppUtils.setPdfTemplateNameToDataMap(response.constituentTemplates || []);
            const responseToSave = { ...response, templateIdToNameMap, templateNameToDataMap };
            dispatch(EditPrescriptionActions.saveTemplatesResponse(responseToSave));
        });
    };

    static saveTemplatesResponse = (data: any) => {
        return { type: SAVE_EDIT_PRESCRIPTION_TEMPLATES_RESPONSE, payload: data }
    }

    static updateEditConsultationDetails = (response: IEditConsultationResponse) => {
        return { type: UPDATE_EDIT_CONSULTATION_DETAILS, payload: response }
    }

    static savePatientPrescriptionPDF = (appointmentId: number, prescription: File, type: string) => {
        return ApiManager.getAlbusApis().uploadPrescription(appointmentId, prescription, type);
    }

    static savePatientPlanPDF = (appointmentId: number, plan: File, type: string) => {
        return ApiManager.getAlbusApis().uploadPlan(appointmentId, plan, type);
    }

    static savePatientPlanNew = (consultation: IAppointmentScheduleResponse, prescription: IPrescription, patientPlan: IPatientLifestylePlanWrapper, planId: string, status: ConsultationStatusConstant, isSelf: boolean, medicalProfile?: any) => {
        return ApiManager.getOrionApis().savePatientPlanNew(consultation, prescription, patientPlan, planId, status, isSelf, medicalProfile);
    }

    static clearEditPrescriptionDetails = () => {
        return { type: CLEAR_EDIT_PRESCRIPTION_DETAILS };
    }

    static fetchEditConsultationDetails = async (dispatch: any, patientId: number, appointmentId: number, curefitId: number, isSelf: boolean, doctorProfile: IDoctorProfile, subServiceType: string): Promise<IEditConsultationResponse> => {
        let editConsultation: IEditConsultationResponse
        await ApiManager.getOrionApis().getEditConsultationDetails(patientId, curefitId, appointmentId, isSelf).then((editConsultationResponse: IEditConsultationResponse) => {
            editConsultation = editConsultationResponse;
            editConsultation.medicalProfile.currentConsultationData = EHRRequestMapper.getConfigBasePrescriptionFromEHRGerPrescriptionResponse(editConsultationResponse.medicalProfile.currentConsultationData)
            if (doctorProfile) {
                EditPrescriptionActions.fetchSuggestionsForSubSections(dispatch, doctorProfile.id, subServiceType);
            }
        });
        return editConsultation
    }

    static fetchSuggestionsForSubSections = (dispatch: any, doctorId: number, doctorType: string, patientId?: number) => {
        ApiManager.getEHRApis().getSubSectionsRecommendations(doctorId, "doctor", doctorType, RECOMMENDATIONS_SECTIONS[doctorType] || []).then((response: any) => {
            dispatch({
                type: SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS,
                payload: response.data || {}
            })
        });
    }

    static storeDoctorRecommendations(recommendations: any, key: string) {
        return {
            type: SAVE_EDIT_SUB_SECTIONS_RECOMMENDATIONS,
            payload: { [key]: recommendations }
        }
    }

    static fetchTreatmentPlanSuggestions = (dispatch: any, doctorId: number, diagnosis?: Array<string>) => {
        if (diagnosis && diagnosis.length > 0) {
            ApiManager.getEHRApis().getTreatmentPlanTemplates(doctorId, diagnosis)
                .then((response: Array<ITreatmentPlanTemplateResponseObj>) => {
                    dispatch({
                        type: UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA,
                        payload: response || []
                    })
                });
        }
        else {
            dispatch({
                type: UPDATE_EDIT_SUGGESTIONS_CONSULTATION_DATA,
                payload: []
            })
        }
    }
}


